
import { Product } from "@/types/product";

export const ipbasetProducts: Product[] = [
  {
    id: "ibt-tc-1-bx",
    groupId: "ipbaset",
    name: "IBT-TC-1-BX",
    description: "The IBT Series AV Distribution Solution consists of two transceiver devices, IBT-1-BX (box) and IBT-1-WP1 (1 gang wall unit) are the building blocks to create up to a 255x255 low cost 4K60 4:4:4 matrix using a network switch. This is not your typical AV over IP solution. The IBT Series has the simplicity of HDBaseT with the scalability of AVoIP. We refer to this as IPBaseT.\n\nHere is how it works. Each unit can be set as a transmitter or receiver and can be addressed from 0 to 255. If it is point to point, set one to transmitter and another to receiver, set it to address zero and connect with CAT cabling or Fiber accordingly. If it is to be used as a distribution amplifier, set one as a transmitter and the amount required for receivers at address zero, and connect to the appropriate network switch brand and size we recommend in the documentation. To make a switch or matrix, set the devices accordingly to be transmitters and receivers, and then set the transmitters address starting at 1 and same for receivers. Now with a simple multicast or RS-232 command that is no different than an off the shelf matrix, the units will route accordingly. Yes, it is that simple.\n\nThe IBT Series is meant to only use a network switch as a matrix to \"glue\" the IBT devices together that is on our list of recommend switches so it will work out of the box with little setup for plug and play operation.",
    features: [
      "Transceiver (Encoder or Decoder Selectable)",
      "4K60 4:4:4 with Zero Frame Latency",
      "HDMI In/Out",
      "PoE LAN",
      "IPBaseT LAN Port",
      "SFP for Single or Multi-mode Fiber",
      "RS-232, IR, CEC",
      "USB 2.0 Extension",
      "Front Display with Buttons",
      "Analog Audio Line In/Out",
      "Rack Mount 4 in 1RU or 16 in 4RU",
      "Consumes as Little as 3 Watts"
    ],
    image: "/lovable-uploads/f3d6ba50-9d6f-47f8-90d1-58e7bb23eb9b.png",
    images: [
      "/lovable-uploads/f3d6ba50-9d6f-47f8-90d1-58e7bb23eb9b.png",
      "/lovable-uploads/56a1755b-4753-4c85-8418-9b044ce92492.png",
      "/lovable-uploads/677aca6b-6dbe-443b-9225-663c4d2a7828.png",
      "/lovable-uploads/9e249f58-5d98-498b-a5ef-d4f7704ef3fe.png",
      "/lovable-uploads/c65af65e-d216-4576-8621-fcd213fde93f.png"
    ],
    slug: "ibt-tc-1-bx"
  },
  {
    id: "ibt-1-wp-1",
    groupId: "ipbaset",
    name: "IBT-1-WP1",
    description: "The IBT Series AV Distribution Solution consists of two transceiver devices, IBT-1-BX (box) and IBT-1-WP1 (1 gang wall unit) are the building blocks to create up to a 255x255 low cost 4K60 4:4:4 matrix using a network switch. This is not your typical AV over IP solution. The IBT Series has the simplicity of HDBaseT with the scalability of AVoIP. We refer to this as IPBaseT.\n\nHere is how it works. Each unit can be set as a transmitter or receiver and can be addressed from 0 to 255. If it is point to point, set one to transmitter and another to receiver, set it to address zero and connect with CAT cabling or Fiber accordingly. If it is to be used as a distribution amplifier, set one as a transmitter and the amount required for receivers at address zero, and connect to the appropriate network switch brand and size we recommend in the documentation. To make a switch or matrix, set the devices accordingly to be transmitters and receivers, and then set the transmitters address starting at 1 and same for receivers. Now with a simple multicast or RS-232 command that is no different than an off the shelf matrix, the units will route accordingly. Yes, it is that simple.\n\nThe IBT Series is meant to only use a network switch as a matrix to \"glue\" the IBT devices together that is on our list of recommend switches so it will work out of the box with little setup for plug and play operation.",
    features: [
      "Transceiver (Encoder or Decoder Selectable)",
      "4K60 4:4:4 with Zero Frame Latency",
      "HDMI In/Out",
      "PoE LAN",
      "CEC",
      "USB-C 2.0 Extension",
      "Rear Dip Switch for Configuration",
      "Consumes as Little as 3 Watts",
      "Single Gang Available in White or Black"
    ],
    image: "/lovable-uploads/d27f50ed-5988-4f9c-a3e1-0ed2d4f6c999.png",
    images: [
      "/lovable-uploads/d27f50ed-5988-4f9c-a3e1-0ed2d4f6c999.png",
      "/lovable-uploads/a5cffa09-ebeb-4aa0-ad08-c4df54d18ac0.png"
    ],
    slug: "ibt-1-wp-1"
  }
];
